import { render } from "./BlockRenderer.vue?vue&type=template&id=660cf649"
import script from "./BlockRenderer.vue?vue&type=script&lang=js"
export * from "./BlockRenderer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__